import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { OrderDetailsPage } from '@/components/OrderDetailsPage';
import { SuperAdminOnly } from '@/components/SuperAdminOnly';
import { LoadingIcon } from '@/components/ui+/LoadingIcon';

export const Route = createFileRoute('/a/orders/$orderId')({
  staticData: {
    breadcrumbs: [{ label: 'Orders', url: '/a/orders' }, { label: 'Order Details' }],
  },
  component: Component,
});

function Component() {
  const { orderId } = Route.useParams();
  const { data: order, isError, isPending, error } = useQuery(api.orders.getById, { orderId });

  if (isPending) return <LoadingIcon />;
  if (isError) {
    return (
      <>
        <div>Error loading order.</div>
        <SuperAdminOnly>
          <div>{error.message}</div>
        </SuperAdminOnly>
      </>
    );
  }
  if (order === null) return <div>Order not found</div>;

  return <OrderDetailsPage orderWrap={order} />;
}
